import * as yup from 'yup';

export const employmentDataSchema = yup.object().shape({
    OccupationalLevel: yup.number()
        .nullable()
        .required("Occupational Level is required")
        .transform((curr, orig) => orig === '' ? null : curr),
    
    EmployeeType: yup.number()
        .nullable()
        .required("Employment Type is required")
        .transform((curr, orig) => orig === '' ? null : curr),
    
    StartDateDateTime: yup.date()
        .nullable()
        .when('hasEntires', {
            is: true,
            then: yup.date()
                .nullable()
                .required('Start Date is required'),
            otherwise: yup.date().nullable(),
        })
        .test(
            'start-before-end',
            'Start Date must be before or equal to End Date',
            function (startDate) {
                const { EndDateDateTime } = this.parent;
                if (!startDate || !EndDateDateTime) 
                    return true;
                return new Date(startDate) <= new Date(EndDateDateTime);
            }
        ),
});